export const precisionRenderables = ['Cu', 'Fe', 'Mn', 'Mo', 'Zn'];

export const renderables = [
  'N',
  'P2O5',
  'K2O',
  'S',
  'Ca',
  'Mg',
  'B',
  ...precisionRenderables,
  'Cl',
];

export const editorRenderables = ['NO3', 'NH4', 'NH2', ...renderables.slice(1)];

export const PEMmap = {
  etec: 'etec_id',
  cultura: 'cultura_id',
  data: 'data',
  estado: 'estado_id',
  municipio: 'cidade_id',
};
